export const handleNon200 = (resp: Response) => {
  if (!resp.ok || resp.status !== 200) {
    return resp.text().then(txt => {
      throw new Error(`Unexpected response code ${resp.status}: ${txt}`);
    });
  }
  return resp;
};
